<template>
    <div class="drag_content">
        <draggable v-model="list" @start="drag = true" @end="drag = false" @change="list_change" item-key="id"
                   style="width: 100%;">
            <template #item="{ element, index }">
                <div class="drag_content_info">
                    <div
                        style="position: absolute;top:0;left: 0;width:90px;height:110px;display: flex;justify-content: center;align-items: center;z-index: 99999999;">
                        <div
                            style="height:30px;width: 50px;cursor: pointer;color: #333333;font-size: 16px;display: flex;justify-content: center;align-items: center;">
                            <div>{{ element.user_score_rank }}</div>
                            <el-icon>
                                <ArrowDown/>
                            </el-icon>
                        </div>
                    </div>
                    <div class="drag_content_list">
                        <div class="drag_content_list_item">
                            <div style="width: 40px;height:30px;"></div>
                            <div style="width: 300px;white-space: nowrap;overflow: hidden;cursor: pointer;">
                                {{ element.toudang_gailv }}{{ element.chongwenbao }}{{ element.zhuanye_mingcheng }}
                            </div>
                            <div style="font-size:12px;color: #999999;">
                                
                                &nbsp;&nbsp;&nbsp;&nbsp;{{ element.type_str }}&nbsp;&nbsp;&nbsp;&nbsp;
                                等效分:{{ element.forecast_low_score }} / 学费:{{ element.fees }} / 人数:{{
                                    element.num
                                }}
                            </div>
                        </div>
                        <div class="drag_content_list_item">
                            <div style="width: 40px;height:30px;"></div>
                            <div style="width: 300px;white-space: nowrap;overflow: hidden;">
                                <el-tag size="small" style="margin-right: 3px;font-size:12px;" type="info"
                                        v-if="element.discipline_ranking_major_str !== ''">
                                    {{ element.discipline_ranking_major_str }}
                                </el-tag>
                                <el-tag size="small" style="margin-right: 3px;font-size:12px;" type="info"
                                        v-if="element.postgraduate_major_str !== ''">{{
                                        element.postgraduate_major_str
                                    }}
                                </el-tag>
                                <el-tag size="small" style="margin-right: 3px;font-size:12px;" type="info"
                                        v-if="element.doctor_major_str !== ''">{{ element.doctor_major_str }}
                                </el-tag>
                                <el-tag size="small" style="margin-right: 3px;font-size:12px;" type="info"
                                        v-if="element.first_class_major_str !== ''">{{ element.first_class_major_str }}
                                </el-tag>
                                <el-tag size="small" style="margin-right: 3px;font-size:12px;" type="info"
                                        v-if="element.nation_feature !== ''">{{ element.nation_feature }}
                                </el-tag>
                                <el-tag size="small" v-if="element.double_first_class_level !== ''" type="info">
                                    {{ element.double_first_class_level }}
                                </el-tag>
                            </div>
                            <div style="font-size:12px;color: #999999;">
                            
                            </div>
                        </div>
                        <div class="drag_content_list_item" style="font-size:12px;color:#999999;min-height:30px;">
                            <div style="margin-left: 40px;">
                                <div v-html="element.remarks"></div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 250px;font-size:12px;color:#999999;">
                        <div
                            style="height:30px;line-height:30px;display: flex;justify-content: right;align-items: center;"
                            v-for="(info, year) in element.historical_data">
                            <div style="width: 50px;text-align: center">{{ year }}</div>
                            <div style="width: 50px;text-align: center">{{ info.number_basics }}</div>
                            <div style="width: 50px;text-align: center">{{ info.low_score_basics }}</div>
                            <div style="width: 50px;text-align: center">{{ info.line_diff_basics }}</div>
                            <div style="width: 50px;text-align: center">{{ info.precedence_basics }}</div>
                        </div>
                    </div>
                    <div style="width: 40px;">
                        <div style="margin-bottom: 10px;">
                            <el-icon :size="20">
                                <Rank/>
                            </el-icon>
                        </div>
                        <div style="margin-bottom: 10px;cursor: pointer;" @click="remove_item(index, element)">
                            <el-icon :size="20">
                                <Delete/>
                            </el-icon>
                        </div>
                    </div>
                </div>
            </template>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import {ElNotification} from "element-plus";

export default {
    components: {
        draggable
    },
    props: {
        favorite_list: {
            type: Array,
            default: [],
        },
        rank_change: {
            type: Function,
            default: null
        },
        sub_rank_change: {
            type: Function,
            default: null
        },
        un_favorite: {
            type: Function,
            default: null
        },
    },
    watch: {
        favorite_list: {
            handler(new_list, old_list) {
                this.list = new_list
            },
            deep: true
        }
    },
    data() {
        return {
            drag: false,
            list: [],
            index: 0,
            index_rank: '',
        };
    },
    methods: {
        list_change(e) {
            let info = e['moved']['element']
            info.user_score_rank = (e['moved']['newIndex'] + 1)
            //console.log(e)
            //console.log(info)
            //console.log(info.user_rank)
            //console.log(this.list)
            this.$emit('sub_rank_change', {'info': info, 'type': 2})
        },
        input(e) {
            this.index_rank = e.replace(/[^\d]/g, '')
        },
        change_rank(info, index) {
            
            let el_popover_index = 'el_popover_' + index
            let new_rank = this.index_rank.replace(/[^\d]/g, '')
            if (new_rank === '' || new_rank < 1 || new_rank > this.list.length) {
                ElNotification({
                    title: '提醒',
                    message: '请输入正确的志愿号!',
                    type: 'warning',
                })
                return false
            }
            this.index_rank = ''
            
            
            info.user_score_rank = new_rank
            this.$refs[el_popover_index].hide()
            this.$emit('sub_rank_change', {'info': info, 'type': 2})
        },
        remove_item(index, plan_info, type = 1) {
            //console.log('un_favorite')
            let param = {
                "plan_id": plan_info.id,
                "school_id": plan_info.school_id,
                "deal_school": 0,
                "danlie_group_key": plan_info.danlie_group_key,
                "key": plan_info.danlie_biaoshi,
                "danlie_biaoshi": plan_info.danlie_biaoshi,
                "major_group_code": plan_info.major_group_code,
                "forecast_low_score": plan_info.school_forecast_low_score,
                "type": 2
            }
            //console.log(param)
            this.$emit('un_favorite', param)
        }
    },
};
</script>
<style scoped>
.drag_content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: white;
    margin: 0 auto;
}

.drag_content_info {
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 0 15px 0 50px;
    padding: 5px 10px;
    border-bottom: 1px rgba(0, 0, 0, 0.12) solid;
    cursor: all-scroll;
    background-color: #F5F4F8;
}

.drag_content_list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.drag_content_list_item {
    width: 665px;
    min-height: 30px;
    display: flex;
    margin-right: 5px;
    justify-content: left;
    align-items: center;
}

.gailv_chongwenbao {
    position: absolute;
    top: 0;
    left: 0;
    width: 23px;
    height: 32px;
    margin-left: 5px;
    font-weight: normal;
    background: url("https://oss.shudaozaixian.com/images/images/gail.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    font-family: 'San Francisco', 'Droid Sans';
    color: white;
    font-size: 9px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 2px 3px 2px;
}
</style>